import { Component, OnInit, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';

import { Member } from './team';

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.scss']
})
export class TeamComponent implements OnInit {

  memberNames = ['nikhil', 'nimita', 'neb', 'david', 'tom'];
  members: Member[];
  /**
   * Decides which of the squares is chosen.
   * - 0 is upper left
   * - 1 is upper right
   * - 2 is lower left
   * - 3 is bottom right
   * - -1 is none
   */
  currMember: number;

  constructor(
    private http: HttpClient,
    @Inject(DOCUMENT) private document: any
  ) {
    this.currMember = -1;
    this.members = [];
  }

  async ngOnInit() {
    // Read in members arr
    const filepath = 'assets/json/team/';
    for (let memberName of this.memberNames) {
      let res = await this.http.get(filepath + memberName + '.json').toPromise();
      this.members.push(res as Member);
    }
  }

  chooseStyle(i: number): any {
    const stylesObj = {'z-index': i};
    if (this.currMember === i) {
      stylesObj['max-height'] = '3000px';
    } else if (this.currMember !== i && this.currMember >= 0) {
      stylesObj['max-height'] = '0px';
      stylesObj['padding-top'] = '0';
      stylesObj['padding-bottom'] = '0';
    }
    return stylesObj;
  }

  scroll(anchor: string) {
    document.getElementById(anchor).scrollIntoView();
  }

}
